import { render, staticRenderFns } from "./CollectivePrintView.vue?vue&type=template&id=378ae653"
import script from "./CollectivePrintView.vue?vue&type=script&lang=js"
export * from "./CollectivePrintView.vue?vue&type=script&lang=js"
import style0 from "./CollectivePrintView.vue?vue&type=style&index=0&id=378ae653&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports